import React from 'react';
import { observer } from 'mobx-react';

// Components
import EditPermittedItems from './EditPermittedItems';
import EditExamNotes from './EditExamNotes';
import EditProctorSettings from './EditProctorSettings';

const EditSection = observer(class EditSection extends React.Component {
  render() {
    switch(this.props.step) {
      case 1:
        return <EditPermittedItems nextStep={this.props.nextStep} prevStep={this.props.prevStep} {...this.props} />;

      case 2:
        return <EditExamNotes nextStep={this.props.nextStep} prevStep={this.props.prevStep} {...this.props} />;

      case 3:
        return <EditProctorSettings prevStep={this.props.prevStep} {...this.props} />;

      default:
        return <EditPermittedItems nextStep={this.props.nextStep} prevStep={this.props.prevStep} {...this.props} />;
    }
  }
})

export default EditSection;


// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditEnrollmentSection.js